    <div id="planNotificationPopup" class="popupu_card notifi_pop_card">

        <div class="popup_inner" *ngIf="notificationList.length > 0">

            <h2>Notifications <a (click)="ClosePlanNotificationList()" href="javascript:void(0)" class="pc_close_btn"><i class="icon-close"></i></a></h2>

            <div class="npc_inner_card">

                <ul>

                    <ng-container *ngFor="let obj of notificationList; let k = index;">
                        <!-- class="nic_new"                      -->
                    <li [ngClass]="{'nic_new': DisplayReadMessageClass(obj)}">
                        <h5>{{obj.display_notification_date}}</h5>
                        <p>{{showTitle(obj)}}</p>
                         <a href="javascript:void(0)" (click)="redirectToCalendarPage(obj)"></a>

                    </li>

                </ng-container>

                </ul>

            </div>

        </div>

    </div>
